import { FORM_IDS as LOGIN_FORM_IDS } from 'providers/UserDetailsProvider';
import { FORM_IDS } from 'providers/PasswordResetProvider';
import { FORM_IDS as NOTIFICATION_FORM_IDS } from 'hooks/useNotificationValidation';
import {
  clearSession as clearSwipeclockSession,
  hasValue,
} from 'swipeclock-frontend';
import { cleanPhoneNumber } from 'helpers/parsing';
import { dispatchAndUnwrap } from 'helpers/api';
import { invalidateToken } from 'store/userSlice';
import { loginApi } from 'services/login';
import { masterDataApi } from 'services/masterDataApi.js';

export const clearSession = (dispatch) => {
  clearSwipeclockSession();
  dispatch(invalidateToken());
};

export async function resetPartnerPassword(dispatch, formData) {
  try {
    const currentPassword = formData.get(FORM_IDS.CURRENT_PASSWORD);
    const password = formData.get(FORM_IDS.PASSWORD);
    const loginDetailsResponse = await dispatchAndUnwrap(
      dispatch,
      masterDataApi.endpoints.getLoginDetails
    );
    const { id, login } = loginDetailsResponse;

    // Confirm current password is correct
    await dispatchAndUnwrap(dispatch, loginApi.endpoints.postPartnerLogin, {
      body: {
        username: login,
        password: currentPassword,
      },
    });

    // Now reset the password
    await dispatchAndUnwrap(
      dispatch,
      masterDataApi.endpoints.resetPartnerPassword,
      {
        loginId: id,
        password,
      }
    );

    return { success: true };
  } catch (error) {
    console.error('resetUserPassword error: ', error);
    return { success: false, error };
  }
}

export async function resetWFHPassword(dispatch, getState, formData) {
  try {
    const { masterEmployeeId } = getState().user ?? { masterEmployeeId: 0 };
    const { email } = await dispatchAndUnwrap(
      dispatch,
      masterDataApi.endpoints.getMasterDataEmployee,
      {
        employeeId: masterEmployeeId,
      }
    );
    const currentPassword = formData.get(FORM_IDS.CURRENT_PASSWORD);

    await dispatchAndUnwrap(dispatch, loginApi.endpoints.postLogin, {
      body: {
        username: email,
        password: currentPassword,
      },
    });

    const password = formData.get(FORM_IDS.PASSWORD);
    await dispatchAndUnwrap(dispatch, masterDataApi.endpoints.resetPassword, {
      employeeId: masterEmployeeId,
      password,
    });
    return { success: true };
  } catch (error) {
    console.error('resetUserPassword error: ', error);
    return { success: false, error };
  }
}

export async function updateWFHUserDetails(dispatch, formData) {
  try {
    const loginDetails = {
      firstName: formData.get(LOGIN_FORM_IDS.FIRST_NAME),
      lastName: formData.get(LOGIN_FORM_IDS.LAST_NAME),
      email: formData.get(LOGIN_FORM_IDS.EMAIL),
    };

    // Prepare login details, removing spaces inside parentheses
    // and around "-" in the phone number
    const phone = formData.get(LOGIN_FORM_IDS.PHONE_NUMBER);
    const cleanedPhone = cleanPhoneNumber(phone);

    if (hasValue(cleanedPhone)) {
      loginDetails.phone = phone
        .replace(/\(\s*(\d+)\s*\)/g, '($1)')
        .replace(/\s*-\s*/g, '-');
    } else {
      loginDetails.phone = '';
    }

    // Dispatch the updateLoginDetails action
    const response = dispatch(
      masterDataApi.endpoints.updateLoginDetails.initiate({
        loginDetails,
      })
    );

    const result = await response.unwrap();
    return { success: true, ...result };
  } catch (error) {
    console.error('updateLoginDetails error: ', error);
    return { success: false, error };
  }
}

export async function updateConfigureNotifications(dispatch, formData) {
  try {
    const loginDetailsResponse = await dispatchAndUnwrap(
      dispatch,
      masterDataApi.endpoints.getLoginDetails
    );
    const { id } = loginDetailsResponse;

    const body = Object.values(NOTIFICATION_FORM_IDS).map((formId) =>
      JSON.parse(formData.get(formId))
    );

    await dispatchAndUnwrap(
      dispatch,
      masterDataApi.endpoints.updateNotificationSettings,
      { loginId: id, body }
    );
    return { success: true };
  } catch (error) {
    console.error('updateConfigureNotifications error: ', error);
    return { success: false, error };
  }
}
